import React from "react";
import type { Course } from "@nelurio/contracts";
import { Badge, Icon } from "@nelurio/ui";
import { useI18n } from "@nelurio/i18n";
import { Link } from "react-router";

export function CourseCard({ course }: { course: Course }) {
  const { formatDate, t, formatNumber } = useI18n();
  const resourceCount = course.resourceCount || 0;
  const dueReviews = course.dueReviewCount || 0;
  return (
    <Link className="course-card" to={`/courses/${course.id}`} style={{ "--course-color": course.color } as React.CSSProperties}>
      <div className="course-card__notch"><span>{course.icon}</span></div>
      <div className="course-card__top">
        <div>
          <small>{course.code}</small>
          <h3>{course.title}</h3>
        </div>
        <span className="course-card__arrow"><Icon name="arrow" size={18} /></span>
      </div>
      <div className="course-card__meta">
        <Badge tone="neutral">{formatNumber(resourceCount)} {t(resourceCount === 1 ? "course.resourceOne" : "course.resources")}</Badge>
        {!!dueReviews && <Badge tone="purple">{formatNumber(dueReviews)} {t(dueReviews === 1 ? "dashboard.dueReviewOne" : "dashboard.dueReviews")}</Badge>}
      </div>
      <div className="course-card__progress">
        <span><i style={{ width: `${course.progress}%` }} /></span>
        <strong>{formatNumber(course.progress)}%</strong>
      </div>
      {course.examDate && <small className="course-card__exam">{t("dashboard.exam")}: {formatDate(course.examDate, { month: "short", day: "numeric" })}</small>}
    </Link>
  );
}
